/**
 * State Values
 */

export const UNAUTHENTICATED = 'unauthenticated';
export const REFRESHING = 'refreshing';
export const AUTHENTICATED = 'authenticated';
